import { render, staticRenderFns } from "./IncidentSummary.vue?vue&type=template&id=76c98849&scoped=true&"
import script from "./IncidentSummary.vue?vue&type=script&lang=js&"
export * from "./IncidentSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c98849",
  null
  
)

export default component.exports